export default __webpack_public_path__ + "static/stack-62f43e4297874a9a6c49b9c24fd5a060.png";